import { useEffect, useRef } from "react";

/**
 * Returns a ref whose `current` is true while the component is mounted and false after unmount.
 * Useful to guard async state updates without sprinkling manual booleans.
 */
export function useIsMountedRef() {
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
}
